import {createSlice} from '@reduxjs/toolkit';
import type {AuthInterface} from '../utils/auth';
import {AuthClientSingleton} from '../utils/auth';
import {getAccessToken, getAccessTokenFromGoogleAuth} from '../actions/pure/auth';
import {getUserProfile} from '../actions/userProfile';
import {getLocalAccessToken, logout} from '../actions/auth';

const DefaultState: AuthInterface = {
    data: {
        kind: 'unknown',
        accessToken: '',
        expiresAt: 0,
    },
    isAuthenticated: false,
    authLoading: false,
    logoutLoading: false,
    error: null,
};

const AuthSlice = createSlice({
    name: 'auth',
    initialState: DefaultState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAccessTokenFromGoogleAuth.pending, (state, action) => {
                state.authLoading = true;
                state.error = null;
            })
            .addCase(getAccessTokenFromGoogleAuth.fulfilled, (state, action) => {
                state.authLoading = false;
                state.data = action.payload;
                AuthClientSingleton.load(action.payload);
                AuthClientSingleton.store(action.payload);
            })
            .addCase(getAccessTokenFromGoogleAuth.rejected, (state, action) => {
                state.authLoading = false;
                state.error = action.error.message ?? 'Unknown Error';
            });
        builder
            .addCase(getAccessToken.pending, (state, action) => {
                state.authLoading = true;
                state.error = null;
            })
            .addCase(getAccessToken.fulfilled, (state, action) => {
                state.authLoading = false;
                state.data = action.payload;
                AuthClientSingleton.load(action.payload);
                AuthClientSingleton.store(action.payload);
            })
            .addCase(getAccessToken.rejected, (state, action) => {
                state.authLoading = false;
                state.error = action.error.message ?? 'Unknown Error';
            });
        builder
            .addCase(getLocalAccessToken.pending, (state, action) => {
                state.authLoading = true;
                state.error = null;
            })
            .addCase(getLocalAccessToken.fulfilled, (state, action) => {
                state.authLoading = false;
                state.data = action.payload;
            })
            .addCase(getLocalAccessToken.rejected, (state, action) => {
                state.authLoading = false;
                state.error = action.error.message ?? 'Unknown Error';
            });
        builder
            .addCase(logout.pending, (state, action) => {
                state.logoutLoading = true;
            })
            .addCase(logout.fulfilled, (state, action) => {
                state.logoutLoading = false;
                state.data = {
                    kind: 'unknown',
                    accessToken: '',
                    expiresAt: 0,
                };
                state.isAuthenticated = false;
                AuthClientSingleton.reset();
            })
            .addCase(logout.rejected, (state, action) => {
                state.logoutLoading = false;
                state.data = {
                    kind: 'unknown',
                    accessToken: '',
                    expiresAt: 0,
                };
                state.isAuthenticated = false;
                AuthClientSingleton.reset();
                state.error = action.error.message ?? 'Unknown Error';
            });

        // !!! AuthProvider bindings start !!!
        builder.addCase(getUserProfile.fulfilled, (state, action) => {
            state.isAuthenticated = true;
            state.error = null;
        });
        builder.addCase(getUserProfile.rejected, (state, action) => {
            state.isAuthenticated = false;
            state.error = action.error.message ?? 'Unknown Error';
            // assume the token is bad
            AuthClientSingleton.reset();
        });
        // !!! AuthProvider bindings end !!!
    },
});

export default AuthSlice.reducer;
